import { AppQueryParams } from '@doda/common/src/constants/queryParams';
import { castToQueryCondition } from '@doda/common/src/redux/features/queryParams';

/**
 * パラメータをURIコンポーネントにエンコードする
 * @param queryParams クエリパラメータ
 * @returns エンコード後クエリパラメータ
 */
export const convertQueryToURI = (queryParams: AppQueryParams) => {
  let query: AppQueryParams = {};
  if (queryParams.ha) {
    // パラメータが年収の時のみURIコンポーネントにエンコードする
    const { ha } = castToQueryCondition(queryParams);
    if (ha) {
      query.ha = [encodeURIComponent(ha)];
    }
  } else {
    // 年収以外はなにもしない
    query = queryParams;
  }
  return query;
};
